import { useEffect, useState } from 'react';

export default function HeroAltaCostura() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full h-[70vh] min-h-[500px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant-haute-couture-atelier-workshop-barcelona-eixample-luxury-interior-manikin-silk-fabrics-natural-daylight-minimalist-space-editorial-photography-warm-tones-soft-grain-texture-panoramic-wide-shot&width=1920&height=1080&seq=101&orientation=landscape"
          alt="Atelier de Alta Costura"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-16 md:pb-24 px-6 lg:px-[7%]">
        <div
          className={`transition-all duration-1000 ease-out ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="font-sans text-white/60 text-[11px] tracking-[0.2em] uppercase font-medium">
            Anthony Sánchez Couture
          </span>
          <h1 className="font-serif text-white text-[clamp(3rem,7vw,6rem)] font-light leading-[1.05] mt-4 max-w-4xl">
            Alta Costura
            <span className="block italic font-light mt-1">Artesanal</span>
          </h1>
          <p className="font-sans text-white/80 text-base md:text-lg max-w-xl leading-relaxed mt-6">
            Prendas únicas hechas a medida en nuestro atelier de Barcelona.
            Cada pieza es un templo de arte, pasión y dedicación absoluta.
          </p>
        </div>
      </div>
    </section>
  );
}